import * as tslib_1 from "tslib";
import { OnInit, ErrorHandler } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material';
import { State } from '../state-view/state.model';
import { MatSnackBar } from '@angular/material';
import { AuthService } from '../../auth/auth/auth.service';
import { UserService } from '../user/user.service';
import { Review } from '../models/review.model';
import { NgxGalleryOptions, NgxGalleryImage } from 'ngx-gallery';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { ImageUploadComponent } from '../image-upload/image-upload.component';
var WriteReviewComponent = /** @class */ (function () {
    function WriteReviewComponent(dialog, dialogRef, data, _auth, _userService, _errorHandler, _snackBar) {
        var _this = this;
        this.dialog = dialog;
        this.dialogRef = dialogRef;
        this.data = data;
        this._auth = _auth;
        this._userService = _userService;
        this._errorHandler = _errorHandler;
        this._snackBar = _snackBar;
        this.entities = [];
        this.airportEntities = [];
        this.FBOEntities = [];
        this.businessEntities = [];
        this.flyingClubEntities = [];
        this.state = State.Empty;
        this.newReview = true;
        this.writtenPhotoIds = [];
        this.newPhotoIds = [];
        this.onRatingClick = function ($event) {
            _this.onClickResult = $event;
            // this.writeRating($event);
            _this.ratingValue = $event.rating;
        };
        this.onSubRatingClick = function ($event, index) {
            _this.onClickResult = $event;
            _this.tempSubRatings[index].rating = $event.rating;
        };
        this.selectChange = function ($event) {
            _this.entityChange();
        };
    }
    WriteReviewComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.data.airport) {
            this.airportEntity = {
                id: this.data.airport.airportId,
                name: this.data.airport.name,
                type: 'Airport'
            };
            this.entities.push(this.airportEntity);
            this.airportEntities.push(this.airportEntity);
            this.initialEntity = this.airportEntity;
            this.selectedEntity = this.airportEntity;
            for (var _i = 0, _a = this.data.airport.businesses; _i < _a.length; _i++) {
                var currentBusiness = _a[_i];
                var currentEntity = {
                    id: currentBusiness.id,
                    name: currentBusiness.name,
                    type: 'Business'
                };
                this.entities.push(currentEntity);
                if (currentBusiness.isFbo) {
                    this.FBOEntities.push(currentEntity);
                }
                else {
                    this.businessEntities.push(currentEntity);
                }
            }
            this.FBOEntities.sort(function (a, b) {
                if (a.name < b.name) {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }
                return 0;
            });
            this.businessEntities.sort(function (a, b) {
                if (a.name < b.name) {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }
                return 0;
            });
            for (var _b = 0, _c = this.data.airport.flyingClubs; _b < _c.length; _b++) {
                var currentBusiness = _c[_b];
                var currentEntity = {
                    id: currentBusiness.id,
                    name: currentBusiness.name,
                    type: 'Flying Club'
                };
                this.entities.push(currentEntity);
                this.flyingClubEntities.push(currentEntity);
            }
            this.flyingClubEntities.sort(function (a, b) {
                if (a.name < b.name) {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }
                return 0;
            });
        }
        else if (this.data.business) {
            var businessEntity = void 0;
            if (this.data.business.flyingClub && (this.data.business.flyingClub.clubAircraft || this.data.business.flyingClub.clubMembers)) {
                businessEntity = {
                    id: this.data.business.id,
                    name: this.data.business.name,
                    type: 'Flying Club'
                };
                this.flyingClubEntities.push(businessEntity);
            }
            else {
                businessEntity = {
                    id: this.data.business.id,
                    name: this.data.business.name,
                    type: 'Business'
                };
                if (this.data.business.isFbo) {
                    this.FBOEntities.push(businessEntity);
                }
                else {
                    this.businessEntities.push(businessEntity);
                }
            }
            this.entities.push(businessEntity);
            this.initialEntity = businessEntity;
            this.selectedEntity = businessEntity;
            for (var _d = 0, _e = this.data.business.airports; _d < _e.length; _d++) {
                var currentAirport = _e[_d];
                var currentEntity = {
                    id: currentAirport.airportId,
                    name: currentAirport.name,
                    type: 'Airport'
                };
                this.entities.push(currentEntity);
                this.airportEntities.push(currentEntity);
            }
            this.airportEntities.sort(function (a, b) {
                if (a.name < b.name) {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }
                return 0;
            });
        }
        this.currentReview = this.data.userReview;
        if (this.currentReview && (this.currentReview.title || this.currentReview.review || this.currentReview.rating)) {
            this.newReview = false;
            if (this.data.airport) {
                this.data.airport.reviewSummary.avgSubRatings.forEach(function (subRating) {
                    var found = false;
                    _this.currentReview.subRatings.forEach(function (innerSubrating) {
                        if (innerSubrating.feature === subRating.feature) {
                            found = true;
                        }
                    });
                    if (!found) {
                        var tempRating = {
                            feature: subRating.feature,
                            rating: 0
                        };
                        _this.currentReview.subRatings.push(tempRating);
                    }
                });
                // this.currentReview.subRatings = JSON.parse(JSON.stringify(this.data.airport.reviewSummary.avgSubRatings));
            }
            if (this.data.business) {
                this.data.business.reviewSummary.avgSubRatings.forEach(function (subRating) {
                    var found = false;
                    _this.currentReview.subRatings.forEach(function (innerSubrating) {
                        if (innerSubrating.feature === subRating.feature) {
                            found = true;
                        }
                    });
                    if (!found) {
                        var tempRating = {
                            feature: subRating.feature,
                            rating: 0
                        };
                        _this.currentReview.subRatings.push(tempRating);
                    }
                });
                // this.currentReview.subRatings = JSON.parse(JSON.stringify(this.data.business.reviewSummary.avgSubRatings));
            }
            this.currentReview.subRatings.forEach(function (subRating) {
                if (subRating.rating === null) {
                    subRating.rating = 0;
                }
            });
        }
        this.chosenEntity = null;
        this.galleryOptions = [
            {
                width: '341px',
                // height: '255px', // for block with image preview
                height: '80px',
                thumbnailsColumns: 3,
                image: false,
                imageSize: 'contain',
                //  imageAnimation: NgxGalleryAnimation.Slide
                thumbnailsMargin: 5,
                thumbnailMargin: 5,
                imageArrowsAutoHide: true,
                thumbnailsArrowsAutoHide: true
            }
        ];
        if (this.data.userReview && this.data.userReview.galleryPhotos) {
            this.galleryImages = this.data.userReview.galleryPhotos;
        }
        else {
            this.galleryImages = [];
        }
        if (this.data.userReview && this.data.userReview.photos) {
            this.data.userReview.photos.forEach(function (photo) {
                _this.writtenPhotoIds.push(photo.photoId);
            });
        }
        else {
            this.writtenPhotoIds = [];
        }
        this.setFormValues();
    };
    WriteReviewComponent.prototype.setFormValues = function (entityLoaded) {
        if (entityLoaded === void 0) { entityLoaded = false; }
        if (!this.currentReview) {
            this.reviewText = '';
            this.reviewTitle = '';
            this.ratingValue = 0;
            if (this.data.airport) {
                this.tempSubRatings = JSON.parse(JSON.stringify(this.data.airport.reviewSummary.avgSubRatings));
                // deep copy array of objects by value
            }
            else if (this.data.business) {
                this.tempSubRatings = JSON.parse(JSON.stringify(this.data.business.reviewSummary.avgSubRatings));
                // deep copy array of objects by value
            }
            this.tempSubRatings.forEach(function (subRating) {
                subRating.rating = 0;
            });
            this.entitySelected = entityLoaded;
        }
        else {
            if (this.currentReview.review) {
                this.reviewText = this.currentReview.review;
            }
            else {
                this.reviewText = '';
            }
            if (this.currentReview.title) {
                this.reviewTitle = this.currentReview.title;
            }
            else {
                this.reviewTitle = '';
            }
            if (this.currentReview.rating) {
                this.ratingValue = this.currentReview.rating;
            }
            else {
                this.ratingValue = 0;
            }
            if (this.currentReview.subRatings && this.currentReview.subRatings.length > 0) {
                this.tempSubRatings = JSON.parse(JSON.stringify(this.currentReview.subRatings)); // deep copy array of objects by value
            }
            else {
                this.tempSubRatings = JSON.parse(JSON.stringify(this.data.business.reviewSummary.avgSubRatings));
            }
            // this.tempSubRatings = this.currentReview.subRatings;
            this.entitySelected = true;
        }
        this.tempSubRatings.forEach(function (subRating) {
            if (subRating.rating === null) {
                subRating.rating = 0;
            }
        });
    };
    WriteReviewComponent.prototype.selectEntity = function () {
        this.entitySelected = true;
        this.selectedEntity = this.chosenEntity;
        this.entityChange();
    };
    WriteReviewComponent.prototype.resetChosen = function () {
        this.entitySelected = false;
        this.currentReview = null;
    };
    WriteReviewComponent.prototype.submitForm = function (value) {
        this.writeReview(value);
        // this.dialogRef.close();
    };
    WriteReviewComponent.prototype.entityChange = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, e_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = this;
                        return [4 /*yield*/, this._userService.getUserReview(this.selectedEntity)];
                    case 1:
                        _a.currentReview = _b.sent();
                        this.setFormValues(true);
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _b.sent();
                        this._errorHandler.handleError(e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    WriteReviewComponent.prototype.writeReview = function (v) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var workingReview, snackBarOpts, review_1, businessId, e_2, errorMessage;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._auth.authenticated || !this._auth.endUser) {
                            this._auth.redirectToLogin();
                            return [2 /*return*/];
                        }
                        workingReview = new Review();
                        snackBarOpts = { duration: 2000 };
                        this.state = State.Loading;
                        // create a new review object if the user hasn't rated this entity
                        /* if (!this.currentReview) {
                          this.currentReview = new Review();
                          newRow = true;
                        }
                        this.currentReview.review = v.reviewField;
                        this.currentReview.title = this.reviewTitle;
                        this.currentReview.rating = this.ratingValue;
                        if (this.currentReview.rating === 0) {
                          this._snackBar.open(`Overall rating required.`, 'Dismiss', { duration: 5000 });
                          return;
                          // this.currentReview.rating = null;
                        }
                        console.log(this.tempSubRatings);
                        this.currentReview.subRatings = [];
                        this.tempSubRatings.forEach( (subRating) => {
                          if (subRating.rating > 0) {
                            console.log(subRating);
                            this.currentReview.subRatings.push(subRating);
                          }
                        });
                        console.log(this.currentReview); */
                        workingReview.review = v.reviewField;
                        workingReview.title = this.reviewTitle;
                        workingReview.rating = this.ratingValue;
                        if (workingReview.rating === 0) {
                            this._snackBar.open("Overall rating required.", 'Dismiss', { duration: 5000 });
                            return [2 /*return*/];
                            // this.currentReview.rating = null;
                        }
                        workingReview.subRatings = [];
                        this.tempSubRatings.forEach(function (subRating) {
                            if (subRating.rating > 0) {
                                workingReview.subRatings.push(subRating);
                            }
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        review_1 = null;
                        if (!this.newReview) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._userService.postReview(workingReview, this.selectedEntity)];
                    case 2:
                        review_1 = _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this._userService.putReview(this.currentReview.id, workingReview, this.selectedEntity)];
                    case 4:
                        review_1 = _a.sent();
                        _a.label = 5;
                    case 5:
                        this.newPhotoIds.forEach(function (photoId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var photo;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this._userService.putReviewPhoto(review_1.id, photoId, this.selectedEntity)];
                                    case 1:
                                        photo = _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        this._snackBar.open("Review saved.", 'Dismiss', snackBarOpts);
                        businessId = -1;
                        if (this.selectedEntity.type === 'Business') {
                            businessId = this.selectedEntity.id;
                        }
                        this.dialogRef.close({ success: true, newPhotoIds: this.newPhotoIds, businessId: businessId });
                        return [3 /*break*/, 7];
                    case 6:
                        e_2 = _a.sent();
                        errorMessage = 'An error occurred saving your review. Please try again later.';
                        if (e_2.error.message === 'A review already exists for this customer.') {
                            errorMessage = e_2.error.message;
                        }
                        this._snackBar.open(errorMessage, 'Dismiss', snackBarOpts);
                        this._errorHandler.handleError(e_2);
                        // Set state to error, then reset after a few seconds to allow retry.
                        this.state = State.Error;
                        setTimeout(function () {
                            _this.state = State.Content;
                        }, 2000);
                        this.dialogRef.close({ success: true });
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    WriteReviewComponent.prototype.deleteImage = function (index) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var dialogRef;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                dialogRef = this.dialog.open(ConfirmationDialogComponent, {
                    width: '350px',
                    data: 'Delete this image?'
                });
                dialogRef.afterClosed().subscribe(function (result) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    var snackBarOpts, review, e_3;
                    var _this = this;
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!result) return [3 /*break*/, 6];
                                snackBarOpts = { duration: 2000 };
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 5, , 6]);
                                if (!(index < this.writtenPhotoIds.length)) return [3 /*break*/, 3];
                                return [4 /*yield*/, this._userService.deleteReviewPhoto(this.writtenPhotoIds[index], this.selectedEntity.type)];
                            case 2:
                                review = _a.sent();
                                this.writtenPhotoIds.splice(index, 1);
                                return [3 /*break*/, 4];
                            case 3:
                                this.newPhotoIds.splice(index, 1);
                                _a.label = 4;
                            case 4:
                                this.galleryImages.splice(index, 1);
                                return [3 /*break*/, 6];
                            case 5:
                                e_3 = _a.sent();
                                this._snackBar.open('An error occurred deleting the image. Please try again later.', 'Dismiss', snackBarOpts);
                                this._errorHandler.handleError(e_3);
                                // Set state to error, then reset after a few seconds to allow retry.
                                this.state = State.Error;
                                setTimeout(function () {
                                    _this.state = State.Content;
                                }, 2000);
                                return [3 /*break*/, 6];
                            case 6: return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    WriteReviewComponent.prototype.openAddImageDialog = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var dialogRef;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                dialogRef = this.dialog.open(ImageUploadComponent, {
                    width: '500px',
                    data: { images: this.galleryImages, entity: this.selectedEntity, newPhotoIds: this.newPhotoIds }
                });
                dialogRef.afterClosed().subscribe(function (result) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                    var snackBarOpts;
                    var _this = this;
                    return tslib_1.__generator(this, function (_a) {
                        if (result) {
                            snackBarOpts = { duration: 2000 };
                            try {
                                /* this.newPhotoIds.forEach((photoId) => {
                                  if (!this.writtenPhotoIds.includes(photoId)) {
                                    this.writtenPhotoIds.push(photoId);
                                  }
                                }); */
                                // console.log('addImage: ', this.newPhotoIds);
                            }
                            catch (e) {
                                this._snackBar.open('An error occurred deleting the review. Please try again later.', 'Dismiss', snackBarOpts);
                                this._errorHandler.handleError(e);
                                // Set state to error, then reset after a few seconds to allow retry.
                                this.state = State.Error;
                                setTimeout(function () {
                                    _this.state = State.Content;
                                }, 2000);
                            }
                        }
                        return [2 /*return*/];
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    WriteReviewComponent.prototype.cancel = function () {
        this.galleryImages.splice(this.galleryImages.length - this.newPhotoIds.length, this.newPhotoIds.length);
        this.dialogRef.close({ success: false, newPhotoIds: [] });
    };
    return WriteReviewComponent;
}());
export { WriteReviewComponent };
